import React from 'react';
import { EssaySendSidebar } from './essay-send-sidebar';
import { EssaySendContent } from './essay-send-content';
import useAuthorityLevel from '@/app/hooks/useAuthorityLevel';
import Error404 from 'src/app/components/Error404';
import { Dashboard } from '@/layouts/dashboard';

export function EssaySend({ essayId, studentId }) {
  const authorityLevel = useAuthorityLevel();

  const isAdmin = authorityLevel !== 'student';

  if (!isAdmin && studentId) return <Error404 />;
  if (isAdmin && !studentId) return <Error404 />;

  return (
    <Dashboard>
      <EssaySendSidebar essayId={essayId} />
      <EssaySendContent
        essayId={essayId}
        studentId={studentId}
      />
    </Dashboard>
  );
}
